import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components

import AppStatusClosedModal from '@components/individualPortal/dashboard/modals/AppStatusClosedModal';
import CancelAppModal from '@components/individualPortal/dashboard/modals/CancelAppModal';
import ChangePlansModal from '@components/individualPortal/dashboard/modals/ChangePlansModal';
import CreateTicketModal from '@components/individualPortal/dashboard/modals/CreateTicketModal';
import ExemptionNumberModal from '@modules/tobacco-exempt/ExemptionNumberModal';
import FailureModal from '@components/individualPortal/dashboard/modals/FailureModal';
import FileSizeExceedingErrorModal from '@components/individualPortal/dashboard/modals/FileSizeExccedingErrorModal';
import GetAssistanceModal from '@components/individualPortal/dashboard/modals/GetAssistanceModal';
import MailingAddressUpdatingModal from '@components/individualPortal/dashboard/modals/MailingAddressUpdatingModal';
import QHPIneligibleModal from '@components/individualPortal/dashboard/modals/QHPIneligibleModal';
import OverrideCommentModal from '@components/individualPortal/dashboard/modals/OverrideCommentModal';
import ReusePriorApp from '@components/individualPortal/dashboard/modals/ReusePriorApp';
import PickDiffPlanModal from '@components/individualPortal/dashboard/modals/PickDiffPlanModal';
import ContactChangeModal from '@components/individualPortal/dashboard/modals/ContactChangeModal';

// ActionCreators

import { fetchCountiesForZipcode, setCounty, validateAddress } from '@actions/ssap/ssapActionCreators';
import { otpSend, otpVerify } from '@actions/individualPortal/preferences/communicationPreferencesActionCreators';

// Constants

import { dashboardModalTypes } from '@constants/individualPortal/dashboard/modals/dashboardModalTypes';




const ModalContainer = props => {
    const {
        actions,
        counties,
        data,
        methods,
        modal,
        modal: {
            modalType
        },
        ssapActions,
        ssapForm,
        ...restProps
    } = props;

    const extendedProps = {
        ...restProps,
        actions,
        data,
        modal
    };

    const getModal = () => {
        switch (modalType) {
            case dashboardModalTypes.APP_STATUS_CLOSED_MODAL:
                return <AppStatusClosedModal {...extendedProps} />;

            case dashboardModalTypes.CANCEL_APP_MODAL:
                return <CancelAppModal {...extendedProps} />;

            case dashboardModalTypes.CHANGE_PLANS_MODAL:
                return <ChangePlansModal {...extendedProps} />;

            case dashboardModalTypes.CREATE_TICKET_MODAL:
                return <CreateTicketModal {...extendedProps} />;

            case dashboardModalTypes.EXEMPTION_NUMBER_MODAL:
                return <ExemptionNumberModal {...extendedProps} />;

            case dashboardModalTypes.FAILURE_MODAL:
                return <FailureModal {...extendedProps} />;

            case dashboardModalTypes.FILE_SIZE_EXCEEDING_ERROR_MODAL:
                return <FileSizeExceedingErrorModal {...extendedProps} />;

            case dashboardModalTypes.GET_ASSISTANCE:
                return <GetAssistanceModal {...extendedProps} />;

            case dashboardModalTypes.MAILING_ADDRESS_UPDATING_MODAL:
                return <MailingAddressUpdatingModal {...{ ...extendedProps, actions: { ...actions, ...ssapActions }, counties, methods }} />;

            case dashboardModalTypes.OVERRIDE_COMMENT_MODAL:
                return <OverrideCommentModal {...{ ...extendedProps, methods }} />;

            case dashboardModalTypes.PICK_DIFF_PLAN:
                return <PickDiffPlanModal {...extendedProps} />;

            case dashboardModalTypes.QHP_INELIGIBLE_MODAL:
                return <QHPIneligibleModal {...extendedProps }/>;

            case dashboardModalTypes.VERIFY_PHONE_MODAL:
            case dashboardModalTypes.CHANGE_PHONE_MODAL:
            case dashboardModalTypes.CHANGE_EMAIL_MODAL:
                return <ContactChangeModal {...{ ...extendedProps, actions: { ...actions, ...ssapActions }, counties, methods, ssapForm }} />;

            case dashboardModalTypes.REUSE_PRIOR_APP:
                return <ReusePriorApp {...extendedProps} />;
            default:
                return null;
        }
    };

    return getModal();
};

const mapStateToProps = state => ({
    counties: state.ssap.counties,
    environment: state.common.environment,
    methods: state.ssap.methods,
    ssapForm: state.ssap.form,
});

const mapDispatchToProps = dispatch => ({
    ssapActions: bindActionCreators({
        fetchCountiesForZipcode,
        otpSend,
        otpVerify,
        setCounty,
        validateAddress
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
